import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getLocation = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Location/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getLocationMaster = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Location/SearchMaster`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};


export const createLocation = (payload) => {
  return axios.post(`${URL_ORI}/api/Location`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdLocation = (id) => {
  return axios
    .get(`${URL_ORI}/api/Location/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateLocation = (payload) => {
  return axios.put(`${URL_ORI}/api/Location`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteLocation = (payload) => {
  return axios.delete(`${URL_ORI}/api/Location`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
